// Styles for indiviual activity panels

export const panelWrapperCss = {
  display: "flex",
  flexDirection: "column" as const,
  height: "auto",
};

export const scrollContainerCss = {
  flex: 1,
  minHeight: "min-content" as const,
  overflow: "auto" as const,
};
